import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './AppShell'

const OverviewPage = lazy(() => import('../features/overview/OverviewPage'))
const SchedulePage = lazy(() => import('../features/schedule/SchedulePage'))
const TemplatesPage = lazy(() => import('../features/templates/TemplatesPage'))
const TemplateDetailPage = lazy(() => import('../features/templates/TemplateDetailPage'))
const InventoryPage = lazy(() => import('../features/inventory/InventoryPage'))
const InventoryWorksPage = lazy(() => import('../features/inventory/InventoryWorksPage'))
const MatrixPage = lazy(() => import('../features/matrix/MatrixPage'))
const ProductCatalogPage = lazy(() => import('../features/products/ProductCatalogPage'))
const ReferenceLibraryPage = lazy(() => import('../features/references/ReferenceLibraryPage'))
const MembersPage = lazy(() => import('../features/members/MembersPage'))
const SettingsPage = lazy(() => import('../features/settings/SettingsPage'))

export default function App() {
  return <Suspense fallback={<div className="route-loading"><i/><span>正在加载页面…</span></div>}><Routes><Route element={<AppShell/>}>
    <Route index element={<Navigate to="/overview" replace/>}/>
    <Route path="overview" element={<OverviewPage/>}/>
    <Route path="schedule" element={<SchedulePage/>}/>
    <Route path="templates" element={<TemplatesPage/>}/>
    <Route path="templates/:templateId" element={<TemplateDetailPage/>}/>
    <Route path="inventory" element={<InventoryPage/>}/>
    <Route path="inventory/works" element={<InventoryWorksPage/>}/>
    <Route path="matrix" element={<MatrixPage/>}/>
    <Route path="products" element={<ProductCatalogPage/>}/>
    <Route path="references" element={<ReferenceLibraryPage/>}/>
    <Route path="members" element={<MembersPage/>}/>
    <Route path="settings" element={<SettingsPage/>}/>
    <Route path="*" element={<Navigate to="/overview" replace/>}/>
  </Route></Routes></Suspense>
}
